import AppointmentRoom from './AppointmentRoom'

export default class AppointmentRoomOld extends AppointmentRoom {
  static entity = 'appointmentRoomsOld'
}
